import { ClubListPage } from './../../normalgame/club-list/club-list.page';
import { ItemListManagementPage } from './../../club/item-list-management/item-list-management.page';
import { Component, EventEmitter, Input, OnInit, Output, Sanitizer, ViewEncapsulation, HostListener } from '@angular/core';
import { LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { BookingAgentClubSetting, ClubData, ClubInfo, PlainScoreCard } from 'src/data/mygolf.data';

import * as moment from 'moment';
import * as global from 'src/globals';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

export class PullupMenuData {
  id?: string;
  name?: string;
  shortName?: string;
  iconUrl?: string;
  data?: any;
  disabled?: boolean;
}

export class MessageData {
  title?: string;
  content?: string;
}
/***
 @param dataList - list of items to display in structure of
 * {
  id?: string;
  name?: string;
  shortName?: string;
  iconUrl?: string;
 * }
  @param headerTitle - string
  @param mode - default 'common' , 'scoringCompetition'
 *
 */
@Component({
  selector: 'app-common-pullup-menu',
  templateUrl: './common-pullup-menu.component.html',
  styleUrls: ['./common-pullup-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommonPullupMenuComponent implements OnInit {
  @Input() app: any;
  @Input() dataList: Array<PullupMenuData>;
  @Input() headerTitle: string;
  @Input() subTitle: string;
  @Input() mode: string = 'common';
  @Input() message: MessageData;
  @Input() showConfirmBtn: boolean = true;
  @Input() showCancelBtn: boolean = true;

  @Input() header: string = 'Confirm';
  @Input() yesText: string = 'Yes';
  @Input() noText: string = 'No';
  @Input() confirmMessage: string = 'Are you sure you want to proceed ?';
  @Output() yes: EventEmitter<any> = new EventEmitter();
  @Output() no: EventEmitter<any> = new EventEmitter();
  @Input() showCloseBtn: boolean = true;
  @Input() scorecard: PlainScoreCard;
  @Input() buggyNo: string;

  @Input() firstBtnTxt: string = '';
  @Input() secondBtnTxt: string = '';

  @Input() firstDateText: string = 'From Date';
  @Input() secondDateText: string = 'To Date';
  @Input() hasFirstDate: boolean = false;
  @Input() hasSecondDate: boolean = false;

  @Input() inputText: string = '';
  @Input() dataId: any;
  @Input() otherRef: string;
  selectedItem: any;
  firstDate: string;
  secondDate: string;

  @Input() receiptMode: string = 'bookingDate';
  @Input() clubAgentList: Array<BookingAgentClubSetting>;

  @Input() originalImage: string;
  @Input() image: Array<string> = [];
  @Input() imageTopDown: string = 'left';

  @Input() selectedValue: string = null;
  @Input() contentMessage: string = '';
  @Input() placeholder: string = '';

  constructor(
    private mdlCtrl: ModalController,
    private flightService: ClubFlightService,
    private loadingCtrl: LoadingController,
    private toastCtl: ToastController,
    private platform: Platform,
    private mg2uUtil: mygolfUtils
  ) {
    console.debug('init common pullup [0] : ', this.dataList);
    this.firstDate = moment().format('YYYY-MM-DD');
    // if(this.hasSecondDate)
    this.secondDate = moment().format('YYYY-MM-DD');
    if (this.mode === 'infoImage') {
      if (this.isMobileLayout()) {
        this.imageTopDown = 'top';
      }
    }
  }

  ngOnInit() {
    console.debug('init common pullup [1] : ', this.dataList);
    if (this.dataId) {
      if (this.mode === 'multi-booking-receipts') {
        this.getClubData();
      }
    }
    if (this.originalImage) {
      this.initImages();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.isMobileLayout()) {
      this.imageTopDown = 'top';
    } else this.imageTopDown = 'left';
  }
  onClick(data: PullupMenuData) {
    if (data?.disabled !== undefined && data?.disabled) return;
    this.mdlCtrl.dismiss(data);
  }

  onClickCancel() {
    this.mdlCtrl.dismiss();
  }

  onClickConfirm() {
    if (this.mode === 'date-confirmation') {
      this.mdlCtrl.dismiss({
        firstDate: this.firstDate,
        secondDate: this.secondDate,
      });
    }
    if (this.mode === 'multi-booking-receipts') {
      if (this.receiptMode === 'bookingDate' && !this.selectedBookingAgent && this.userType().includes('club')) {
        MessageDisplayUtil.showErrorToast('Please select a booking agent', this.platform, this.toastCtl, 3000, 'bottom');
        return;
      }
      if (this.userType().includes('agent') && this.receiptMode === 'bookingDate' && !this.selectedClub) {
        MessageDisplayUtil.showErrorToast('Please select a club', this.platform, this.toastCtl, 3000, 'bottom');
        return;
      }
      this.onGenerateMultiBookingBills();
      // this.mdlCtrl.dismiss({
      //   inputText: this.inputText
      // });
    } else if (this.mode === 'simpleInputField') {
      this.mdlCtrl.dismiss({
        inputField: this.inputText,
      });
    } else {
      this.mdlCtrl.dismiss(true);
    }
  }

  onClickConfirmDate() {}

  onClickDual(type) {
    this.mdlCtrl.dismiss(type);
  }

  onClickApply() {
    if (!this.selectedItem) return;
    let _selectedData = this.dataList.find(item => {
      return item.id === this.selectedItem;
    });
    this.mdlCtrl.dismiss(_selectedData);
  }
  handleYesClick() {
    this.yes.emit(true);
  }

  handleNoClick() {
    this.no.emit(false);
  }

  async onGenerateMultiBookingBills() {
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      message: 'Generating Bookings Bills',
    });
    let _bookingReferences = this.normalizeValues(this.inputText).split(',');
    let _clubId = this.dataId;
    if (this.userType().includes('agent')) {
      _clubId = this.selectedClub?.clubId;
    }

    loader.present().then(() => {
      if (this.receiptMode === 'bookingReference') {
        this.flightService.getMultiItemizedBill(_clubId, _bookingReferences).subscribe(
          data => {
            let _url = global.MygolfServer + data;
            // if(!this.platform.is('capacitor')) {
            loader.dismiss().then(() => {
              window.open(_url);
              // rewoke URL after 15 minutes
              setTimeout(
                () => {
                  window.URL.revokeObjectURL(_url);
                },
                15 * 60 * 1000
              );
            });
            // } else {
            // this.openWithInAppBrowser(_url,null)
            // }
          },
          error => {
            if (loader) loader.dismiss().then(() => {});
          }
        );
      } else if (this.receiptMode === 'bookingDate') {
        let _bookingAgent = this.selectedBookingAgent.id;
        let _startDate = moment(this.firstDate).format('YYYY-MM-DD');
        let _endDate = moment(this.secondDate).format('YYYY-MM-DD');

        this.flightService.getAgentMultiItemizedBill(_clubId, _bookingAgent, _startDate, _endDate).subscribe(
          data => {
            let _url = global.MygolfServer + data;
            // if(!this.platform.is('capacitor')) {
            loader.dismiss().then(() => {
              window.open(_url);
              // rewoke URL after 15 minutes
              setTimeout(
                () => {
                  window.URL.revokeObjectURL(_url);
                },
                15 * 60 * 1000
              );
            });
            // } else {
            // this.openWithInAppBrowser(_url,null)
            // }
          },
          error => {
            console.debug('report error : ', error);
            let _error = null;
            if (error?.error) _error = JSON.parse(error?.error);
            let _msg = 'Something went wrong with the server. Please try again';
            if (_error?.errorMessage) _msg = _error?.errorMessage;

            if (loader)
              loader.dismiss().then(() => {
                MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
              });
          }
        );
      }
    });
  }

  getClubData() {
    this.flightService.getClubData(this.dataId).subscribe((data: ClubData) => {
      if (data) {
        this.otherRef = data.bookingReferencePrefix;
        this.getClubAgentList(data.clubId);
      }
    });
  }

  @Input() selectedBookingAgent: any;
  getClubAgentList(clubId?: number) {
    let _params = {
      clubId: clubId,
    };
    this.flightService.getAgentClubSetup(_params).subscribe((data: any) => {
      console.debug('get agent club setup ', data);
      if (data && data.items.length > 0) {
        this.clubAgentList = data.items;
      }
    });
  }

  normalizeValues(input: string): string {
    const prefix = `${this.otherRef}-`;
    return input
      .split(',')
      .map(value => {
        // Trim any leading/trailing whitespace from the value
        value = value.trim();
        // Check if the value starts with the required prefix
        if (!value.startsWith(prefix)) {
          // Check if the value starts with a digit
          if (!/^\d/.test(value)) {
            // Replace any non-digit starting values with the prefix
            return `${prefix}${value.replace(/^[^\d]*/, '')}`;
          } else {
            // If it starts with a digit, just add the prefix
            return `${prefix}${value}`;
          }
        }
        return value;
      })
      .join(',');
  }

  onToggleReceiptMode() {
    if (this.receiptMode === 'bookingReference') this.receiptMode = 'bookingDate';
    else if (this.receiptMode === 'bookingDate') this.receiptMode = 'bookingReference';
  }

  onSelectAgent() {
    return new Promise((resolve, reject) => {
      this.getAgentClubSetup().then(async (result: any) => {
        console.debug('agent club setup: ', result);
        let _params = {
          openedModal: true,
          initTab: 'partners',
          headerTitle: 'Select an Agent',
          // toggleSearch: true,
          fromClub: true,
          selectedPartners: result.agents,
          partnerType: 'booking_agent',
          // clubGroupId: _groupId,
        };
        let clubModal = await this.mdlCtrl.create({
          component: ItemListManagementPage,
          componentProps: {
            openedModal: true,
            initTab: 'partners',
            headerTitle: 'Select an Agent',
            // toggleSearch: true,
            fromClub: true,
            selectedPartners: result.agents,
            partnerType: 'booking_agent',
            // clubGroupId: _groupId,
          },
        });

        clubModal.onDidDismiss().then((data: any) => {
          console.debug('selected agent : ', data, result);
          if (data && data?.data?.success) {
            this.selectedBookingAgent = data?.data?.partner;
            resolve({
              status: 'success',
              data: data?.data?.partner,
            });
          }
        });
        clubModal.present();
      });
    });
  }

  getAgentClubSetup() {
    return new Promise((resolve, reject) => {
      let _agents = [];
      let _agentSettings = [];
      let _params = {
        clubId: this.dataId,
      };
      this.flightService.getAgentClubSetup(_params).subscribe((data: any) => {
        console.debug('get agent club setup ', data);
        if (data && data.items.length > 0) {
          data.items.forEach((item, idx, arr) => {
            if (item.discountCompany) {
              _agents.push(item.discountCompany);
              _agentSettings.push(item);
            }
            if (arr.length - 1 === idx) {
              resolve({
                status: 'success',
                agents: _agents,
                agentSettings: _agentSettings,
              });
              // this.mg2uUtil.setClubsForAgent(_clubs);
            }
          });
          // this.mg2uUtil.setClubsForAgent()
        }
      });
    });
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  initImages() {
    if (this.originalImage && this.originalImage.length > 0 && this.originalImage.includes(',')) this.image = this.originalImage.split(',');
    else if (this.originalImage && this.originalImage.length > 0 && !this.originalImage.includes(',')) this.image.push(this.originalImage);
    else this.image.push(this.originalImage);
  }

  isImageArray() {
    console.debug('is image array ', Array.isArray(this.image), this.image);
    return Array.isArray(this.image);
  }

  userType() {
    return this.mg2uUtil.getUserType().toLowerCase();
  }

  selectedClub: ClubInfo;
  async onSelectClub() {
    let clubId;

    let club = await this.mdlCtrl.create({
      component: ClubListPage,
      componentProps: {
        openedModal: true,
      },
    });

    club.onDidDismiss().then((data: any) => {
      console.debug('select club [0]: ', data, this.selectedBookingAgent);
      if (data?.data) {
        this.flightService.getClubInfo(data?.data?.clubId).subscribe((clubInfo: ClubInfo) => {
          console.debug('select club [1]: ', data, clubInfo, this.selectedBookingAgent);
          if (clubInfo) {
            this.selectedClub = clubInfo;
          }
        });
      }
      // if (!!clubId) {
      //   this.flightService.getClubInfo(clubId)
      //     .subscribe((data: ClubInfo) => {
      //       if (data) {
      //         this.selectedClub = data
      //       }
      //     })
      // }
    });
    club.present();
  }
  // // Test cases
  // console.log(normalizeValues("TPGCC-123,TPGCC-124")); // Output: TPGCC-123,TPGCC-124
  // console.log(normalizeValues("123,TPGCC-124"));       // Output: TPGCC-123,TPGCC-124
  // console.log(normalizeValues("123,456,124"));         // Output: TPGCC-123,TPGCC-456,TPGCC-124
}
